import { __decorate, __param } from 'vscode/external/tslib/tslib.es6.js';
import { IRemoteAgentService } from 'vscode/vscode/vs/workbench/services/remote/common/remoteAgentService.service';
import { RemoteExtensionsScannerChannelName } from '../../../../platform/remote/common/remoteExtensionsScanner.js';
import 'vscode/vscode/vs/platform/instantiation/common/instantiation';
import { language } from 'vscode/vscode/vs/base/common/platform';
import { URI } from 'vscode/vscode/vs/base/common/uri';
import { IUserDataProfileService } from 'vscode/vscode/vs/workbench/services/userDataProfile/common/userDataProfile.service';
import { IRemoteUserDataProfilesService } from 'vscode/vscode/vs/workbench/services/userDataProfile/common/remoteUserDataProfiles.service';
import { IWorkbenchEnvironmentService } from 'vscode/vscode/vs/workbench/services/environment/common/environmentService.service';
import { ILogService } from 'vscode/vscode/vs/platform/log/common/log.service';
import { IActiveLanguagePackService } from 'vscode/vscode/vs/workbench/services/localization/common/locale.service';

let RemoteExtensionsScannerService = class RemoteExtensionsScannerService {
    constructor(remoteAgentService, environmentService, userDataProfileService, remoteUserDataProfilesService, logService, activeLanguagePackService) {
        this.remoteAgentService = remoteAgentService;
        this.environmentService = environmentService;
        this.userDataProfileService = userDataProfileService;
        this.remoteUserDataProfilesService = remoteUserDataProfilesService;
        this.logService = logService;
        this.activeLanguagePackService = activeLanguagePackService;
    }
    whenExtensionsReady() {
        return this.withChannel(channel => channel.call('whenExtensionsReady'), undefined);
    }
    async scanExtensions() {
        try {
            const languagePack = await this.activeLanguagePackService.getExtensionIdProvidingCurrentLocale();
            return await this.withChannel(async (channel) => {
                const profileLocation = this.userDataProfileService.currentProfile.isDefault ? undefined : (await this.remoteUserDataProfilesService.getRemoteProfile(this.userDataProfileService.currentProfile)).extensionsResource;
                const scannedExtensions = await channel.call('scanExtensions', [language, profileLocation, this.environmentService.extensionDevelopmentLocationURI, languagePack]);
                scannedExtensions.forEach((extension) => {
                    extension.extensionLocation = URI.revive(extension.extensionLocation);
                });
                return scannedExtensions;
            }, []);
        }
        catch (error) {
            this.logService.error(error);
            return [];
        }
    }
    async scanSingleExtension(extensionLocation, isBuiltin) {
        try {
            return await this.withChannel(async (channel) => {
                const extension = await channel.call('scanSingleExtension', [extensionLocation, isBuiltin, language]);
                if (extension !== null) {
                    extension.extensionLocation = URI.revive(extension.extensionLocation);
                }
                return extension;
            }, null);
        }
        catch (error) {
            this.logService.error(error);
            return null;
        }
    }
    withChannel(callback, fallback) {
        const connection = this.remoteAgentService.getConnection();
        if (!connection) {
            return Promise.resolve(fallback);
        }
        return connection.withChannel(RemoteExtensionsScannerChannelName, (channel) => callback(channel));
    }
};
RemoteExtensionsScannerService = ( __decorate([
    ( __param(0, IRemoteAgentService)),
    ( __param(1, IWorkbenchEnvironmentService)),
    ( __param(2, IUserDataProfileService)),
    ( __param(3, IRemoteUserDataProfilesService)),
    ( __param(4, ILogService)),
    ( __param(5, IActiveLanguagePackService))
], RemoteExtensionsScannerService));

export { RemoteExtensionsScannerService };
